import { render, staticRenderFns } from "./topicItem.vue?vue&type=template&id=20317f09&scoped=true&"
import script from "./topicItem.vue?vue&type=script&lang=js&"
export * from "./topicItem.vue?vue&type=script&lang=js&"
import style0 from "./topicItem.vue?vue&type=style&index=0&id=20317f09&lang=scss&scoped=true&"
import style1 from "./topicItem.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20317f09",
  null
  
)

export default component.exports